class EPCartExtras {
  constructor() {
    this.init();
    this.bindCartRefresh();
  }

  init() {
    this.bindToggles();
    this.bindVatForm();
    this.bindDiscountForm();
    this.prefillFromCart();
  }

  bindCartRefresh() {
    document.addEventListener('on:cart:after-merge', () => this.init());
    document.addEventListener('on:cart-drawer:after-open', () => this.init());
  }

  // ===== TOGGLE PANELS (accordion behavior) =====

  bindToggles() {
    const toggles = document.querySelectorAll('[data-pb-toggle]');
    toggles.forEach((toggle) => {
      if (toggle.dataset.pbBound === 'true') return;
      toggle.dataset.pbBound = 'true';

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        const targetName = toggle.dataset.pbToggle;
        this.togglePanel(targetName);
      });
    });
  }

  togglePanel(name) {
    const targetPanel = document.querySelector(`[data-pb-panel="${name}"]`);
    if (!targetPanel) return;

    const isCurrentlyOpen = !targetPanel.hasAttribute('hidden');

    // Chiudi tutti i pannelli
    document.querySelectorAll('[data-pb-panel]').forEach((panel) => {
      panel.setAttribute('hidden', '');
    });

    // Aggiorna lo stato active dei toggle
    document.querySelectorAll('[data-pb-toggle]').forEach((toggle) => {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
    });

    // Se non era già aperto, aprilo (click sul toggle attivo lo chiude)
    if (!isCurrentlyOpen) {
      targetPanel.removeAttribute('hidden');
      const toggle = document.querySelector(`[data-pb-toggle="${name}"]`);
      if (toggle) {
        toggle.classList.add('is-active');
        toggle.setAttribute('aria-expanded', 'true');
        // Focus sull'input solo se non è readonly (campo non locked)
        const input = targetPanel.querySelector('input');
        if (input && !input.readOnly) {
          setTimeout(() => input.focus(), 50);
        }
      }
    }
  }

  // ===== PARTITA IVA → NOTE =====

  bindVatForm() {
    const form = document.querySelector('[data-pb-vat-form]');
    if (!form || form.dataset.pbBound === 'true') return;
    form.dataset.pbBound = 'true';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('input[name="vat"]');
      if (!input) return;

      const isApplied = form.dataset.pbApplied === 'true';
      const button = form.querySelector('button[type="submit"]');

      // ===== Stato REMOVE =====
      if (isApplied) {
        this.setButtonState(button, 'loading');
        try {
          await this.updateCartNote('');
          this.setVatFormState(form, '', false);
          this.setButtonState(button, 'success');
          this.showFeedback(form, 'P.IVA rimossa.');
        } catch (err) {
          console.error('[EPCartExtras] VAT remove error:', err);
          this.setButtonState(button, 'error');
          this.showFeedback(form, 'Errore. Riprova.', true);
        }
        return;
      }

      // ===== Stato APPLY =====
      const vat = input.value.trim();
      if (!vat) {
        // Campo vuoto: ignora silenziosamente, non cancellare nulla
        input.focus();
        return;
      }

      this.setButtonState(button, 'loading');
      try {
        await this.updateCartNote(vat);
        this.setVatFormState(form, vat, true);
        this.setButtonState(button, 'success');
        this.showFeedback(form, 'P.IVA salvata.');
      } catch (err) {
        console.error('[EPCartExtras] VAT save error:', err);
        this.setButtonState(button, 'error');
        this.showFeedback(form, 'Errore. Riprova.', true);
      }
    });
  }

  setVatFormState(form, value, isApplied) {
    const input = form.querySelector('input[name="vat"]');
    const button = form.querySelector('[data-pb-action-label]');
    if (!input || !button) return;

    input.value = value;
    input.readOnly = isApplied;
    form.dataset.pbApplied = isApplied ? 'true' : 'false';
    button.textContent = isApplied ? 'Rimuovi' : 'Applica';
  }

  async updateCartNote(vat) {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    let note = cart.note || '';

    // Rimuove vecchia P.IVA se presente
    note = note.replace(/P\.IVA:\s*\S*/gi, '').trim();

    if (vat) {
      note = (note + '\nP.IVA: ' + vat).trim();
    }

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ note }),
    });
  }

  // ===== CODICE SCONTO (Editions '25 API) =====

  bindDiscountForm() {
    const form = document.querySelector('[data-pb-discount-form]');
    if (!form || form.dataset.pbBound === 'true') return;
    form.dataset.pbBound = 'true';

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const input = form.querySelector('input[name="discount"]');
      if (!input) return;

      const isApplied = form.dataset.pbApplied === 'true';
      const button = form.querySelector('button[type="submit"]');

      // ===== Stato REMOVE =====
      if (isApplied) {
        this.setButtonState(button, 'loading');
        try {
          await this.applyDiscount('');
          this.setDiscountFormState(form, '', false);
          this.setButtonState(button, 'success');
          this.showFeedback(form, 'Codice rimosso.');
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        } catch (err) {
          console.error('[EPCartExtras] discount remove error:', err);
          this.setButtonState(button, 'error');
          this.showFeedback(form, 'Errore. Riprova.', true);
        }
        return;
      }

      // ===== Stato APPLY =====
      const code = input.value.trim();
      if (!code) {
        input.focus();
        return;
      }

      this.setButtonState(button, 'loading');
      try {
        const result = await this.applyDiscount(code);

        if (result.status === 'applied') {
          this.setDiscountFormState(form, code.toUpperCase(), true);
          this.setButtonState(button, 'success');
          this.showFeedback(form, `Codice "${code.toUpperCase()}" applicato.`);
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        } else if (result.status === 'not_combinable') {
          this.setButtonState(button, 'error');
          this.showFeedback(form, 'Codice non cumulabile con la promo attiva.', true);
          // NON cancelliamo il valore digitato
        } else {
          this.setButtonState(button, 'error');
          this.showFeedback(form, 'Codice non valido o scaduto.', true);
        }
      } catch (err) {
        console.error('[EPCartExtras] discount error:', err);
        this.setButtonState(button, 'error');
        this.showFeedback(form, 'Errore nell\'applicazione del codice.', true);
      }
    });
  }

  setDiscountFormState(form, value, isApplied) {
    const input = form.querySelector('input[name="discount"]');
    const button = form.querySelector('[data-pb-action-label]');
    if (!input || !button) return;

    input.value = value;
    input.readOnly = isApplied;
    form.dataset.pbApplied = isApplied ? 'true' : 'false';
    button.textContent = isApplied ? 'Rimuovi' : 'Applica';
  }

  /**
   * Applica codice sconto via /cart/update.js (Shopify Editions '25).
   * Ritorna:
   *  - { status: 'applied', cart } se applicato con successo
   *  - { status: 'not_combinable', cart } se valido ma non cumulabile
   *  - { status: 'invalid', cart } se non esiste o scaduto
   *  - { status: 'removed', cart } se richiesta rimozione (code vuoto)
   */
  async applyDiscount(code) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: code }),
    });

    if (!res.ok) {
      return { status: 'invalid' };
    }

    const cart = await res.json();

    // Rimozione
    if (!code) {
      return { status: 'removed', cart };
    }

    const upperCode = code.toUpperCase();
    const codesAfter = cart.discount_codes || [];
    const newCodeEntry = codesAfter.find(d => d.code.toUpperCase() === upperCode);

    // Caso 1: il codice non appare nel cart dopo l'apply → invalid
    if (!newCodeEntry) {
      return { status: 'invalid', cart };
    }

    // Caso 2: appare ma non applicable → non cumulabile o altro motivo
    if (!newCodeEntry.applicable) {
      return { status: 'not_combinable', cart };
    }

    // Caso 3: appare ed è applicable → applicato con successo
    return { status: 'applied', cart };
  }

  // ===== PREFILL =====

  async prefillFromCart() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

      // P.IVA dalla nota
      const vatForm = document.querySelector('[data-pb-vat-form]');
      if (vatForm) {
        let savedVat = '';
        if (cart.note) {
          const match = cart.note.match(/P\.IVA:\s*(\S+)/i);
          if (match) savedVat = match[1];
        }
        this.setVatFormState(vatForm, savedVat, savedVat !== '');
      }

      // Discount code
      const discountForm = document.querySelector('[data-pb-discount-form]');
      if (discountForm) {
        let savedDiscount = '';
        if (cart.discount_codes && cart.discount_codes.length) {
          const active = cart.discount_codes.find(d => d.applicable);
          if (active) savedDiscount = active.code;
        }
        this.setDiscountFormState(discountForm, savedDiscount, savedDiscount !== '');
      }
    } catch (err) {
      console.error('[EPCartExtras] prefill error:', err);
    }
  }

  // ===== UI HELPERS =====

  setButtonState(button, state) {
    if (!button) return;
    button.dataset.state = state;
    button.disabled = state === 'loading';

    if (state === 'success' || state === 'error') {
      setTimeout(() => {
        button.dataset.state = '';
        button.disabled = false;
      }, 2000);
    }
  }

  showFeedback(form, message, isError = false) {
    let feedback = form.querySelector('.pb-form-feedback');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'pb-form-feedback';
      form.appendChild(feedback);
    }
    feedback.textContent = message;
    feedback.classList.toggle('pb-form-feedback--error', isError);

    setTimeout(() => {
      feedback.textContent = '';
      feedback.classList.remove('pb-form-feedback--error');
    }, 4000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new EPCartExtras());
} else {
  new EPCartExtras();
}